import { useMemo } from 'react';
import useReports from './useBreakpoint/useReports';
import { isPinned } from '../components/ViewEditReport/hooks/usePinReport';

export function usePinnedReports() {
	const { reports, availableReportTypes } = useReports();
	return useMemo(() => {
		if (reports === null) {
			return null;
		}
		return availableReportTypes
			.map(({ type }) => reports[type])
			.filter((r) => !!r)
			.flat()
			.filter(isPinned)
			// Sorted by created date for now. Maybe we can improve the pinned reports
			// experience in the future and store date pinned, or customizable order.
			.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
	}, [reports, availableReportTypes]);
}
